const CanvasUtil = require("./CanvasUtil");

const canvases = [];
const locks = new Map();

const requestCanvas = function(width, height) {
	if (!global.document) {
		return;
	}
	width = width || 100;
	height = height || 100;
	for (let i = 0; i < canvases.length; i++) {
		const canvas = canvases[i];
		if (!locks.get(canvas)) {
			canvas.width = width;
			canvas.height = height;
			locks.set(canvas, true);
			CanvasUtil.resetContext(canvas);
			CanvasUtil.incrementCanvasCount({
				source: "TempCanvas",
			});
			return canvas;
		}
	}
	return addNewCanvas(width, height);
};

const releaseCanvas = function(canvas) {
	if (locks.get(canvas)) {
		locks.set(canvas, false);
		CanvasUtil.freeCanvasMemory(canvas, {
			source: "TempCanvas",
		});
	}
};

const addNewCanvas = function(width, height) {
	if (!global.document) {
		return;
	}
	const newCanvas = CanvasUtil.createCanvas(width, height, {
		source: "TempCanvas",
	});
	newCanvas.style.display = "none";
	canvases.push(newCanvas);
	locks.set(newCanvas, true);
	return newCanvas;
};

module.exports = {
	requestCanvas,
	releaseCanvas,
};
